import { useState, useEffect, Suspense } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Helmet } from 'react-helmet'

import AboutUs from '../components/AboutUs'
import Slider from './Slider'
import FormComponent from '../components/FormComponent'
import InstagramFeed from '../components/InstagramFeed'
import Highlights from '../components/Highlights'
import ImageButton from './ImageButton'

import AnalyticsService from '../services/AnalyticsService'


function PageRenderer({ page }) {
  const [navbarHeight, setNavbarHeight] = useState(0)

  useEffect(() => {
    const updateNavbarHeight = () => {
      const height = document.getElementById('navbar-site')
      setNavbarHeight(height.offsetHeight)
    }
    updateNavbarHeight()
    window.addEventListener('resize', updateNavbarHeight)

    const params = {
      hitType: 'pageview',
      page: '/',
      title: 'Página inicial'
    }
    AnalyticsService.send(params)

    return () => window.removeEventListener('resize', updateNavbarHeight)
  }, [])

  return (
    <Suspense fallback={<div>Carregando elementos...</div>}>
      <Helmet>
        <title>{page.title}</title>
        <meta name="description" content={page.title} />
        <meta property="og:title" content={page.title} />
        <meta property="og:description" content={page.title} />
        <meta property="og:image" content={page.title} />
      </Helmet>
      <Container fluid>
        <Row style={{ marginTop: navbarHeight }}>
          <Col id="inicio" xs={12} sm={12} md={12} lg={12}>
            <AboutUs />
          </Col>
          <Col id="sobre" xs={12} sm={12} md={12} lg={12} style={{ display: 'none' }}>
            <InstagramFeed />
          </Col>
          <Col id="portfolio">
            <ImageButton />
          </Col>
          <Col id="clientes" xs={12} sm={12} md={12} lg={12}>
            <Slider title="Nossos Clientes" />
          </Col>
          <Col id="servicos" xs={12} sm={12} md={12} lg={12}>
            <Highlights />
          </Col>
          <Col id="contato" xs={12} sm={12} md={12} lg={12}>
            <FormComponent />
          </Col>
        </Row>
      </Container>
    </Suspense>
  )
}

export default PageRenderer